const IconBase = ({
  size = 18,
  className = '',
  children,
  strokeWidth = 1.8,
  fill = 'none'
}: any) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill={fill}
    viewBox='0 0 24 24'
    strokeWidth={strokeWidth}
    stroke='currentColor'
    style={{ width: size, height: size }}
    className={className}
  >
    {children}
  </svg>
);

export default IconBase;
